//@flow
import { RESOURCE_URL as ASSET_IMAGE } from "../config"
export const BANKTRANSFER = 'bank_transfer';
export const VIRTUALACCOUNT = 'virtual_account';
export const BCA_VA = 'bca_va';
export const BNI_VA = 'bni_va';
export const BRI_VA = 'bri_va';
export const PERMATA_VA = 'permata_va';
export const MANDIRI_VA = 'mandiri_va';
export const CREDITCARD = 'credit_card';
export const BCA_CREDIT_CARD = 'bca_credit_card';
export const MANDIRI_CREDIT_CARD = 'mandiri_credit_card';
export const MANDIRI_DEBIT_CARD = 'mandiri_debit_card';
export const BNI_CREDIT_CARD = 'bni_credit_card';
export const BNI_DEBIT_CARD = 'bni_debit_card';
export const BCA_INSTALLMENTS = 'bca_installments';
export const KREDIVO = 'kredivo';
export const ATOME = 'atome';
export const AKULAKU = 'akulaku';
export const GOPAY = 'gopay';
export const FULLWALLET = 'full_wallet';
export const KICK_POINT = 'kick_point';
export const INSTALLMENTS = 'installments';
export const BCA_KLIK_PAY = 'bca_klikpay';
export const BCA_ONEKLIK = 'bca_oneklik';
export const KREDIVO_INSTALLMENTS_TYPES = [
  {
    value: '30_days', label: '30 Hari',
  },
  {
    value: '3_months', label: '3 Bulan',
  },
  {
    value: '6_months', label: '6 Bulan',
  },
  {
    value: '12_months', label: '12 Bulan',
  },
];

export const getAdmFees = (paymentType, amount, shippingFee, discount) => {
  return 0;
};

export const getAdmTopupFees = (paymentType, amount, shippingFee, discount) => {
  switch (paymentType) {
    case VIRTUALACCOUNT:
    case BCA_VA:
    case BNI_VA:
    case PERMATA_VA:
    case MANDIRI_VA:
    case BRI_VA:
      return 5000;
    case CREDITCARD:
      return Math.floor(parseFloat((amount + shippingFee - discount) * 2.5 / 100)) + 5000;
    case KREDIVO:
      return Math.floor(parseFloat((amount + shippingFee - discount) * 2.3 / 100));
    default:
      return 0;
  }
};

export const DEFAULT_CREDIT_CARD = CREDITCARD;

export const CREDIT_CARD_BCA = BCA_CREDIT_CARD

export const DEFAULT_PAYMENT_METHOD = [
  {
    'id': Math.random(),
    'label': 'BCA Credit Card / Debit Card',
    'payment_method': BCA_CREDIT_CARD,
    'payment_group': 1,
    'type': "credit_card",
    'active': true,
    'logo': `${ASSET_IMAGE}email/bca.png`,
  },
  {
    'id': Math.random(),
    'label': 'BNI Credit Card',
    'payment_method': BNI_CREDIT_CARD,
    'payment_group': 1,
    'type': "credit_card",
    'active': true,
    'logo': `${ASSET_IMAGE}email/bni.png`,
  },
  {
    'id': Math.random(),
    'label': 'BNI Debit Card',
    'payment_method': BNI_DEBIT_CARD,
    'payment_group': 1,
    'type': "credit_card",
    'active': true,
    'logo': `${ASSET_IMAGE}email/bni.png`,
  },
  {
    'id': Math.random(),
    'label': 'BCA Installments',
    'payment_method': BCA_INSTALLMENTS,
    'payment_group': 1,
    'type': 'credit_card',
    'active': true,
    'logo': `${ASSET_IMAGE}email/bca.png`,
  },
  {
    'id': Math.random(),
    'label': 'BCA Card',
    'payment_method': CREDITCARD,
    'payment_group': 1,
    'type': 'credit_card',
    'active': true,
    'logo': `${ASSET_IMAGE}email/bca-card.png`
  },
  {
    'id': Math.random(),
    'label': 'MANDIRI Credit Card',
    'payment_method': MANDIRI_CREDIT_CARD,
    'payment_group': 1,
    'type': "credit_card",
    'active': true,
    'logo': `${ASSET_IMAGE}email/mandiri.png`,
  },
  {
    'id': Math.random(),
    'label': 'MANDIRI Debit Card',
    'payment_method': MANDIRI_DEBIT_CARD,
    'payment_group': 1,
    'type': "credit_card",
    'active': true,
    'logo': `${ASSET_IMAGE}email/mandiri.png`,
  },
  {
    'id': Math.random(),
    'label': 'Credit Card / Debit Card / Installments',
    'payment_method': DEFAULT_CREDIT_CARD,
    'payment_group': 1,
    'type': 'credit_card',
    'active': true,
    'logo': `${ASSET_IMAGE}email/visa-mastercard.png`,
  },
  {
    'id': Math.random(),
    'label': 'Bank Transfer',
    'payment_method': BANKTRANSFER,
    'payment_group': 1,
    'type': 'bank_transfer',
    'active': true,
  },
  {
    'id': Math.random(),
    'label': 'BCA',
    'payment_method': BCA_VA,
    'payment_group': 1,
    'type': 'virtual_account',
    'active': true,
    'logo': `${ASSET_IMAGE}email/bca.png`,
  },
  {
    'id': Math.random(),
    'label': 'MANDIRI',
    'payment_method': MANDIRI_VA,
    'payment_group': 1,
    'type': 'virtual_account',
    'active': true,
    'logo': `${ASSET_IMAGE}email/mandiri.png`,
  },
  {
    'id': Math.random(),
    'label': 'PERMATA',
    'payment_method': PERMATA_VA,
    'payment_group': 1,
    'type': 'virtual_account',
    'active': true,
    'logo': `${ASSET_IMAGE}email/permata.png`,
  },
  {
    'id': Math.random(),
    'label': 'BNI',
    'payment_method': BNI_VA,
    'payment_group': 1,
    'type': 'virtual_account',
    'active': true,
    'logo': `${ASSET_IMAGE}email/bni.png`,
  },
  {
    'id': Math.random(),
    'label': 'BRI',
    'payment_method': BRI_VA,
    'payment_group': 1,
    'type': 'virtual_account',
    'active': true,
    'logo': `${ASSET_IMAGE}email/bri.png`,
  },
  {
    'id': Math.random(),
    'label': 'GOPAY',
    'payment_method': GOPAY,
    'payment_group': 1,
    'type': 'virtual_account',
    'active': true,
    'logo': `${ASSET_IMAGE}email/gopay-icon.png`,
  },
  {
    'id': Math.random(),
    'label': 'Other Virtual Account',
    'payment_method': VIRTUALACCOUNT,
    'payment_group': 1,
    'type': 'virtual_account',
    'active': true,
  },
  {
    'id': Math.random(),
    'label': 'Atome Installments',
    'payment_method': ATOME,
    'payment_group': 2,
    'active': true,
    'logo': `${ASSET_IMAGE}email/atome.png`,
  },
  {
    'id': Math.random(),
    'label': 'Akulaku Installments',
    'payment_method': AKULAKU,
    'payment_group': 2,
    'active': true,
    'logo': `${ASSET_IMAGE}email/akulaku.png`,
  },
  {
    'id': Math.random(),
    'label': 'KREDIVO Installments',
    'payment_method': KREDIVO,
    'payment_group': 2,
    'active': true,
    'logo': `${ASSET_IMAGE}email/kredivo.png`,
  },
  {
    'id': Math.random(),
    'label': 'Full Wallet',
    'payment_method': FULLWALLET,
    'payment_group': 3,
    'active': true,
    'logo': `${ASSET_IMAGE}email/kick_check.png`
  }
];

export const PAYMENT_LOGOS = {
  bca: `${ASSET_IMAGE}email/bca.png`,
  mandiri: `${ASSET_IMAGE}email/mandiri.png`,
  kredivo: `${ASSET_IMAGE}email/kredivo.png`,
  atome: `${ASSET_IMAGE}email/atome.png`,
  akulaku: `${ASSET_IMAGE}email/akulaku.png`,
  masterCard: `${ASSET_IMAGE}email/visa-mastercard.png`,
  bni: `${ASSET_IMAGE}email/bni.png`,
  bri: `${ASSET_IMAGE}email/bri.png`,
  permata: `${ASSET_IMAGE}email/permata.png`,
  gopay: `${ASSET_IMAGE}email/gopay-icon.png`
}
